import { render, staticRenderFns } from "./NotificationMailRecipients.vue?vue&type=template&id=5c642948&"
import script from "./NotificationMailRecipients.vue?vue&type=script&lang=js&"
export * from "./NotificationMailRecipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports